import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
const base_url = process.env.NODE_ENV == "production" ? "https://hooks-28xd.onrender.com" : "http://localhost:4000"

const Signup = () => {
  const navigate = useNavigate();
  const [inputValue, setInputValue] = useState({
    email: "",
    password: "",
    username: "",
  });
  const { email, password, username } = inputValue;
  
  // Redirect to login page when component mounts (optional)
  useEffect(() => {
    toast.info("Signup is temporarily unavailable. Please use existing account or contact support.", {
      position: "bottom-left",
      autoClose: 5000,
    });
    // Uncomment the following lines to automatically redirect to login
    // setTimeout(() => {
    //   navigate("/login");
    // }, 5000);
  }, []);

  const handleOnChange = (e) => {
    const { name, value } = e.target;
    setInputValue({
      ...inputValue,
      [name]: value,
    });
  };

  const handleError = (err) =>
    toast.error(err, {
      position: "bottom-left",
    });
  const handleSuccess = (msg) =>
    toast.success(msg, {
      position: "bottom-right",
    });

  const handleSubmit = async (e) => {
    e.preventDefault();
    handleError("Signup is temporarily disabled");
    // Original signup code commented out
    /*
    try {
      const { data } = await axios.post(
        base_url + "/auth/signup",
        {
          ...inputValue,
        },
        { withCredentials: true, httpOnly: false, sameSite: "none", secure: true }
      );
      const { success, message } = data;
      if (success) {
        handleSuccess(message);
        setTimeout(() => {
          navigate("/tss");
        }, 1000);
      } else {
        handleError(message);
      }
    } catch (error) {
      console.log(error);
    }
    */
    setInputValue({
      ...inputValue,
      email: "",
      password: "",
      username: "",
    });
  };

  return (
    <div className="form_container">
      <h2>Signup Account</h2>
      <div className="temporary-message" style={{color: "red", marginBottom: "20px", textAlign: "center"}}>
        Signup is temporarily unavailable. Please check back later.
      </div>
      <form onSubmit={handleSubmit}>
        <div>
          <label htmlFor="email">Email</label>
          <input
            type="email"
            name="email"
            value={email}
            placeholder="Enter your email"
            onChange={handleOnChange}
          />
        </div>
        <div>
          <label htmlFor="email">Username</label>
          <input
            type="text"
            name="username"
            value={username}
            placeholder="Enter your username"
            onChange={handleOnChange}
          />
        </div>
        <div>
          <label htmlFor="password">Password</label>
          <input
            type="password"
            name="password"
            value={password}
            placeholder="Enter your password"
            onChange={handleOnChange}
          />
        </div>
        <button type="submit" disabled={true}>Submit</button>
        <span>
          Already have an account? <Link to={"/login"}>Login</Link>
        </span>
      </form>
      <ToastContainer />
    </div>
  );
};

export default Signup;